/**
 * When sort_by=stock-available: fetches all pagination pages of the collection,
 * merges products, sorts by stock quantity (highest first), then displays
 * with client-side pagination. Only runs when "By stock available" is selected.
 */
(function () {
  function isStockSortActive() {
    return new URLSearchParams(window.location.search).get('sort_by') === 'stock-available';
  }

  function parseLisFromSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var container = doc.getElementById('ProductGridContainer');
    if (!container) return [];
    var grid = container.querySelector('#product-grid');
    if (!grid) return [];
    return Array.from(grid.querySelectorAll('li[data-product-id]')).map(function (li) {
      var qty = parseInt(li.getAttribute('data-stock-quantity'), 10);
      return { html: li.outerHTML, stockQuantity: isNaN(qty) ? 0 : qty };
    });
  }

  function getCollectionData() {
    var collectionEl = document.querySelector('.collection[data-total-pages]');
    var grid = document.getElementById('product-grid');
    if (!collectionEl || !grid) return null;
    var totalPages = parseInt(collectionEl.getAttribute('data-total-pages'), 10);
    var perPage = parseInt(collectionEl.getAttribute('data-products-per-page'), 10);
    var sectionId = grid.getAttribute('data-id');
    if (!sectionId || totalPages < 1) return null;
    return { totalPages: totalPages, perPage: perPage, sectionId: sectionId, collectionEl: collectionEl, grid: grid };
  }

  function runMergeAndSort() {
    if (!isStockSortActive()) return;
    if (window._collectionStockSortUpdating) return;
    var data = getCollectionData();
    if (!data) return;
    if (data.grid.getAttribute('data-stock-sort-done') === 'true') return;

    window._collectionStockSortUpdating = true;
    var params = new URLSearchParams(window.location.search);
    params.set('section_id', data.sectionId);
    params.set('sort_by', 'title-ascending');

    var collection = data.collectionEl;
    var grid = data.grid;
    var perPage = data.perPage;

    collection.classList.add('loading');

    var allItems = Array.from(grid.querySelectorAll('li[data-product-id]')).map(function (li) {
      var qty = parseInt(li.getAttribute('data-stock-quantity'), 10);
      return { html: li.outerHTML, stockQuantity: isNaN(qty) ? 0 : qty };
    });

    if (data.totalPages <= 1) {
      allItems.sort(function (a, b) {
        return b.stockQuantity - a.stockQuantity;
      });
      grid.innerHTML = allItems.map(function (item) { return item.html; }).join('');
      data.grid.setAttribute('data-stock-sort-done', 'true');
      collection.classList.remove('loading');
      window._collectionStockSortUpdating = false;
      return;
    }

    var fetchPromises = [];
    for (var p = 2; p <= data.totalPages; p++) {
      (function (pageNum) {
        var pageParams = new URLSearchParams(params);
        pageParams.set('page', String(pageNum));
        var url = window.location.pathname + '?' + pageParams.toString();
        fetchPromises.push(
          fetch(url).then(function (r) { return r.text(); }).then(function (html) {
            return parseLisFromSectionHtml(html);
          })
        );
      })(p);
    }

    Promise.all(fetchPromises).then(function (pageResults) {
      pageResults.forEach(function (lis) {
        lis.forEach(function (item) { allItems.push(item); });
      });

      // Sort: highest stock first
      allItems.sort(function (a, b) {
        return b.stockQuantity - a.stockQuantity;
      });

      var totalProducts = allItems.length;
      var totalClientPages = Math.ceil(totalProducts / perPage);

      var prevArrowHtml = '';
      var nextArrowHtml = '';
      var nav = document.querySelector('nav.pagination');
      if (nav) {
        var prevArrow = nav.querySelector('.pagination__item--next.pagination__item-arrow');
        var nextArrow = nav.querySelector('.pagination__item--prev.pagination__item-arrow');
        if (prevArrow) prevArrowHtml = prevArrow.innerHTML;
        if (nextArrow) nextArrowHtml = nextArrow.innerHTML;
      }
      if (!prevArrowHtml) prevArrowHtml = '&lsaquo;';
      if (!nextArrowHtml) nextArrowHtml = '&rsaquo;';

      function updatePageUrl(pageNum) {
        var url = new URL(window.location.href);
        url.searchParams.set('page', String(pageNum));
        url.searchParams.set('sort_by', 'stock-available');
        history.pushState({ page: pageNum, sort_by: 'stock-available' }, '', url.toString());
      }

      function showPage(pageNum) {
        var start = (pageNum - 1) * perPage;
        var end = Math.min(start + perPage, allItems.length);
        var slice = allItems.slice(start, end).map(function (item) { return item.html; });
        grid.innerHTML = slice.join('');
        renderPagination(pageNum, totalClientPages, prevArrowHtml, nextArrowHtml);
        updatePageUrl(pageNum);
        collection.classList.remove('loading');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.dispatchEvent(new CustomEvent('favourites-grid-updated'));
      }

      function renderPagination(currentPage, totalPages, prevArrow, nextArrow) {
        var wrapper = document.querySelector('.pagination-wrapper');
        if (!wrapper || totalPages <= 1) return;

        var nav = wrapper.querySelector('nav.pagination');
        var list = nav && nav.querySelector('ul.pagination__list');
        if (!list) return;

        var parts = [];
        if (currentPage > 1) parts.push({ type: 'prev' });
        parts.push({ type: 'page', num: 1 });
        if (totalPages <= 5) {
          for (var i = 2; i <= totalPages; i++) parts.push({ type: 'page', num: i });
        } else {
          var windowStart = Math.max(2, currentPage - 2);
          var windowEnd = Math.min(totalPages - 1, currentPage + 2);
          if (windowStart > 2) parts.push({ type: 'ellipsis' });
          for (var w = windowStart; w <= windowEnd; w++) parts.push({ type: 'page', num: w });
          if (windowEnd < totalPages - 1) parts.push({ type: 'ellipsis' });
          parts.push({ type: 'page', num: totalPages });
        }
        if (currentPage < totalPages) parts.push({ type: 'next' });

        list.innerHTML = '';
        parts.forEach(function (p) {
          var li = document.createElement('li');
          if (p.type === 'prev') {
            var prevA = document.createElement('a');
            prevA.href = '?page=' + (currentPage - 1) + '&sort_by=stock-available';
            prevA.className = 'pagination__item pagination__item--next pagination__item-arrow link motion-reduce';
            prevA.setAttribute('aria-label', 'Previous');
            prevA.innerHTML = prevArrow;
            prevA.addEventListener('click', function (e) { e.preventDefault(); showPage(currentPage - 1); });
            li.appendChild(prevA);
          } else if (p.type === 'next') {
            var nextA = document.createElement('a');
            nextA.href = '?page=' + (currentPage + 1) + '&sort_by=stock-available';
            nextA.className = 'pagination__item pagination__item--prev pagination__item-arrow link motion-reduce';
            nextA.setAttribute('aria-label', 'Next');
            nextA.innerHTML = nextArrow;
            nextA.addEventListener('click', function (e) { e.preventDefault(); showPage(currentPage + 1); });
            li.appendChild(nextA);
          } else if (p.type === 'ellipsis') {
            li.innerHTML = '<span class="pagination__item">…</span>';
          } else {
            var num = p.num;
            if (num === currentPage) {
              li.innerHTML = '<span class="pagination__item pagination__item--current" aria-current="page" aria-label="Page ' + num + '">' + num + '</span>';
            } else {
              var a = document.createElement('a');
              a.href = '?page=' + num + '&sort_by=stock-available';
              a.className = 'pagination__item link';
              a.setAttribute('aria-label', 'Page ' + num);
              a.textContent = num;
              a.addEventListener('click', function (e) { e.preventDefault(); showPage(num); });
              li.appendChild(a);
            }
          }
          list.appendChild(li);
        });
      }

      data.grid.setAttribute('data-stock-sort-done', 'true');
      window._collectionStockSortShowPage = showPage;
      window._collectionStockSortTotalPages = totalClientPages;
      var urlParams = new URLSearchParams(window.location.search);
      var initialPage = parseInt(urlParams.get('page'), 10);
      if (initialPage >= 1 && initialPage <= totalClientPages) {
        showPage(initialPage);
      } else {
        showPage(1);
      }
      window._collectionStockSortUpdating = false;
    }).catch(function () {
      collection.classList.remove('loading');
      window._collectionStockSortUpdating = false;
    });
  }

  function setStockAvailableInSelects() {
    var sortBy = document.querySelector('#SortBy');
    var sortByMobile = document.querySelector('#SortBy-mobile');
    if (sortBy) { sortBy.value = 'stock-available'; sortBy.setAttribute('data-sort-by', 'stock-available'); }
    if (sortByMobile) sortByMobile.value = 'stock-available';
  }

  function init() {
    if (!isStockSortActive()) return;
    setStockAvailableInSelects();
    runMergeAndSort();
  }

  window.runCollectionStockSort = function () {
    var grid = document.getElementById('product-grid');
    if (grid) grid.removeAttribute('data-stock-sort-done');
    runMergeAndSort();
  };

  window.addEventListener('popstate', function () {
    if (!isStockSortActive()) return;
    if (typeof window._collectionStockSortShowPage !== 'function') return;
    var urlParams = new URLSearchParams(window.location.search);
    var page = parseInt(urlParams.get('page'), 10);
    var total = window._collectionStockSortTotalPages;
    if (total && page >= 1 && page <= total) window._collectionStockSortShowPage(page);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
